<script lang="ts">
import { ChartOptions } from "chart.js";
import { Doughnut, mixins } from "vue-chartjs";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

@Component({
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
})
export default class PhonesGraphDoughnut extends Mixins(mixins.reactiveProp, Doughnut) {
  @Prop() readonly options!: ChartOptions;
  
  mounted(): void {
    this.refreshChart();
  }

  refreshChart(): void {
    if (!this.$refs.canvas) {
      return;
    }
    this.renderChart(this.chartData, this.options);
  }
}
</script>
